import { Dialog } from 'primereact/dialog';
import { classNames } from 'primereact/utils';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCredentials } from '../Slice/AuthSlice';
import { setDialogPasswordResetVisible, setLoginVisible } from '../Slice/DialogSlice';
import { AppDispatch, RootState } from '../Store';
import styles from './dialog.module.scss';

export default function AuthDialogLogin() {

    const username = useSelector((state: RootState) => state.authReducer.auth.credentials?.username);
    const password = useSelector((state: RootState) => state.authReducer.auth.credentials?.password);
    const twophasecode = useSelector((state: RootState) => state.authReducer.auth.credentials?.twophasecode);
    const loginVisible = useSelector((state: RootState) => state.authReducer.dialog.loginVisible);
    const dispatch = useDispatch<AppDispatch>();

    const [twofactorlogin, setTwofactorlogin] = useState<Boolean>(false);


    const handleLoginButton = (e: { preventDefault: () => void; target: any; }) => {
        e.preventDefault();

        
    }

    const headerContent = (
        <div className="">
            <h3>Login</h3>
        </div>
    );

    return (
        <Dialog
            header={headerContent}
            //footer={footerContent}
            visible={loginVisible}
            onHide={() => dispatch(setLoginVisible(false))}
        >
            {!twofactorlogin &&
                <>
                    <div className={classNames(styles.authDialogContent, 'p-dialog-content')}>
                        <form onSubmit={handleLoginButton}>

                            <div>
                                <div>
                                    <label htmlFor='input-auth-username' className={classNames(styles.contextFontBodyBoldL)}>Email</label>
                                </div>
                                <input
                                    className='form-control'
                                    id='input-auth-username'
                                    type='text'
                                    name="username"
                                    value={username}
                                    placeholder={''}
                                    onChange={(event) => {
                                        dispatch(setCredentials({
                                            username: event.target.value,
                                            password: password || '',
                                            twophasecode: twophasecode || ''
                                        }));
                                    }}
                                    autoFocus
                                    tabIndex={0}
                                />
                            </div>
                            <div>
                                <div>
                                    <label htmlFor='input-auth-password' className={classNames(styles.contextFontBodyBoldL)}>Password</label>
                                </div>

                                <input type="password"
                                    className='form-control'
                                    id='input-auth-password'
                                    name="password"
                                    style={{ width: '100%' }}
                                    value={password}
                                    onChange={(event) => {
                                        dispatch(setCredentials({
                                            username: username || '',
                                            password: event.target.value,
                                            twophasecode: twophasecode || ''
                                        }));
                                    }}
                                    tabIndex={1} />
                            </div>

                            <div className={classNames(styles.authDialogFooter)}>
                                <button
                                    type="submit"
                                    onClick={handleLoginButton}
                                    title="Login"
                                    className=" btn btn-primary"
                                    disabled={username === undefined || password === undefined}
                                >Login</button>
                            </div>
                        </form>
                        <button
                            title="Forgot Password"
                            className=" btn btn-light"
                            onClick={() => {
                                dispatch(setLoginVisible(false));
                                dispatch(setDialogPasswordResetVisible(true));
                            }}>Password vergessen</button>
                    </div>

                </>
            }

            {twofactorlogin &&
                <>
                    <div className={classNames(styles.authDialogContent, 'p-dialog-content')}>

                        <form onSubmit={handleLoginButton}>

                            <div>
                                <label htmlFor='input-auth-twophasecode' className={classNames(styles.contextFontBodyBoldL)}>Code</label>
                            </div>

                            <input
                                name="twophasecode"
                                className={classNames('p-inputtext', styles.authInputField)}
                                id='input-auth-twophasecode'
                                type='text'
                                maxLength={6}
                                value={twophasecode}
                                placeholder={''}
                                onChange={(event) => {
                                    dispatch(setCredentials({
                                        username: username || '',
                                        password: password || '',
                                        twophasecode: event.target.value,
                                    }));
                                }}
                                autoFocus
                                tabIndex={0}
                            />

                            <div className={styles.authDialogFooter}>
                                <button
                                    title="Login"
                                    className="btn btn-primary"
                                    disabled={username === undefined || password === undefined}
                                    onClick={() => handleLoginButton} > Login </button>
                                <button
                                    title="Zurück"
                                    className="btn btn-light"
                                    onClick={() => {
                                        setTwofactorlogin(false);
                                        dispatch(setCredentials({
                                            username: username || '',
                                            password: password || '',
                                            twophasecode: ''
                                        }));
                                    }}>Zurück</button>
                            </div>

                        </form>
                    </div>
                </>
            }
        </Dialog>
    )
}
